import http from "./axios_plugin";
import cookies from "@/util/cookies";

class Auth {
  constructor() {
    this.user = {};

    if (this.check()) {
      this.getUser();
    }
  }

  async login(credenciais) {
    let response = await http.post("/login", credenciais);
    this.setUser(response.data);
  }

  logout() {
    this.unsetUser();
  }

  check() {
    if (this.getToken()) {
      return true;
    } else {
      this.unsetUser();
      return false;
    }
  }

  setUser(user) {
    this.user = user;
    window.localStorage.setItem("user", JSON.stringify(user));
    this.setToken(user.api_token);
  }

  unsetUser() {
    window.localStorage.removeItem("user");
    cookies.delete("api_token");
    this.user = {};
  }

  setToken(api_token) {
    cookies.set("api_token", api_token, 365);
  }

  getToken() {
    return cookies.get("api_token");
  }

  getUser() {
    this.user = JSON.parse(window.localStorage.getItem("user"));
    return this.user;
  }

  getAuthHeader() {
    return {
      Authorization: "Bearer " + this.getToken(),
    };
  }
}

const auth = new Auth();

const auth_plugin = {
  install(Vue, options) {
    Vue.prototype.$auth = auth;
  },
};

export { auth_plugin };

export default auth;
